import {Component, Input} from '@angular/core';

@Component({
    selector: 'vui-input-validation',
    templateUrl: './input-validation.component.html',
    styleUrls: ['./input-validation.component.scss']
})
export class InputValidationComponent {
    public _error: string;

    constructor() {

    }

    @Input()
    public set error(error: any) {
        if (error[1] === true) {
            this._error = error[0];
        } else {
            this._error = error[1];
        }
    }
}
